import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  formValuePropType,
  textQuestionPropType
} from './prop_types.js';
import FormInputLabel from './form_input_label.jsx';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import { preventEnterKeyDownSubmit } from './form.jsx';
import { CheckCircleIcon, WarningIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

export const FormTextInput_ViewerVersion2 = ({
  question,
  formValue,
  uniqueFormString,
  onQuestionChange,
  onQuestionTouch
}) => (
  <Fragment>
    <FormInputLabel {...{ question, uniqueFormString }} />
    <div className="form-input">
      <input
        aria-describedby={question.isRequired ? null : 'optional-description'}
        type="text"
        id={`${question.name}-${uniqueFormString}`}
        name={question.name}
        value={formValue.value}
        placeholder={question.placeholder}
        onBlur={() => onQuestionTouch(question)}
        onChange={(e) => onQuestionChange(question, e.target.value)}
        onKeyDown={preventEnterKeyDownSubmit}
      />
      <span className="form-input-status-icon-container">
        {formValue.error ?
          <WarningIcon className="form-input-status-icon" />
          :
          <CheckCircleIcon className="form-input-status-icon" />
        }
      </span>
    </div>

    <div className="form-input-error">
      <p className="form-input-error-text">Please fill in this field.</p>
    </div>
  </Fragment>

);

FormTextInput_ViewerVersion2.propTypes = {
  formValue: formValuePropType.isRequired,
  question: textQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

const LegacyNoLabelTextInput = ({
  formValue,
  question,
  onQuestionChange,
  onQuestionTouch
}) => (
  <Fragment>
    <div htmlFor={question.name} className="form-field-label"></div>
    <input
      type="text"
      className={classnames(
        "form-field",
        "form-field-text",
        formValue.error ? "error" : ""
      )}
      data-field-type="text"
      name={question.name}
      id={question.name}
      value={formValue.value}
      placeholder={question.label + (question.isRequired ? ' *' : '')}
      onBlur={() => onQuestionTouch(question)}
      onChange={(e) => onQuestionChange(question, e.target.value)}
      onKeyDown={preventEnterKeyDownSubmit}
    />
  </Fragment>
);

export const FormTextInput_ViewerVersion1 = ({
  formValue,
  question,
  onQuestionChange,
  onQuestionTouch
}) => (
  question.legacyShouldHideLabel ?
    <LegacyNoLabelTextInput
      formValue={formValue}
      question={question}
      onQuestionChange={onQuestionChange}
      onQuestionTouch={onQuestionTouch}
    />
    : (
      <Fragment>
        <label htmlFor={question.name} className="form-field-label">
          {question.label} {question.isRequired && <span className="form-field-required-indicator">*</span>}
        </label>
        <input
          type="text"
          className={classnames(
            "form-field",
            "form-field-text",
            formValue.error ? "error" : ""
          )}
          data-field-type="text"
          name={question.name}
          id={question.name}
          value={formValue.value}
          onBlur={() => onQuestionTouch(question)}
          onChange={(e) => onQuestionChange(question, e.target.value)}
          onKeyDown={preventEnterKeyDownSubmit}
        />
      </Fragment>
    )
);

FormTextInput_ViewerVersion1.propTypes = {
  formValue: formValuePropType.isRequired,
  question: textQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

const FormTextInput = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormTextInput_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormTextInput_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormTextInput;